import React from 'react';
import { Typography, CardMedia, Grid } from '@material-ui/core';

import ES from 'components/ExplainString';
import explains from 'data/explains'

const data = (
<Typography component="div">
  <h1>Smart Home</h1>

  <h2>Incentive</h2>
  <p>
    Other the years, I brought few commercial smart devices from <ES {...explains['PhilipsHue']}>Philips</ES> and <ES {...explains['Aqara']}>Xiaomi</ES>, each vendor requires their own hub to operate which makes it cumbersome to do automation across vendors. <br/>
    After comprehensive research, I decided to build custom Zigbee Hub on Raspberry Pi. To better utilise Pi's compute power and make device management easier, I used <ES {...explains['Balena']} /> to run Docker Daemon, and run each component as microservices with Docker Compose.
  </p>


  <h2>Architecture and Security</h2>

  <Grid container spacing={3}>
    <Grid item sm={7} xs={12}>
      <img src={require('./arch.png')} />
    </Grid>

    <Grid item sm={5} xs={12} >
      <p style={{wordBreak: 'break-word'}}>
        The Architecture Diagram shows how everything is connected. The Raspberry Pi are running <ES {...explains['BalenaOS']}/> with Docker Daemon and supervisor, allowing update and maintain microservices through <ES {...explains['BalenaCloud']}/>. The Raspberry Pi also has an Zigbee transceiver, allowing the <ES {...explains['Z2M']}/> talk to commercial smart devices and translate them to MQTT topic which can be understand by other microservices. The <ES {...explains['HA']} /> microservices act as frontend and maintain global device state, whereas the <ES {...explains['AD']} /> contains custom event-driven automation scripts that instruct HomeAssistant what to do.
      </p>

    </Grid>
  </Grid>

  <h3>Access Control</h3>
  <p>
    Due to the real-world impact of this application, security is more important then ever. The first action I take is to narrow the scope of port access, exposing only required port in each microservice and further narrow the external port exposed by Raspberry Pi. The second action I take is run each microservices as non-root user, and assign them unique uid, so the Linux file access control is maintained even if a volume is mounted on multiple microservices for debugging. Furthermore, on the application level, Access Control List (ACL) is used for MQTT, so malicious smart devices can not spoof, tamper, disclose any information it does not own.
  </p>

  <h3>Encryption and Data Storage</h3>
  <p>
    To better enforce security and privacy, a local Certificate Authority (CA) is created, and signing keys for microservices that use SSL, then the private key for CA is deleted, making it impossible to add new devices to the network. <br/>
    To further enhance privacy and allow regular backup, data are stored as named volume and mounted to the microservice.
  </p>

  <h2>Future Roadmap</h2>
  {/* <p style={{marginTop: '0px'}}>
    The existing work has layed a stable infrastructure for future development.
  </p> */}


  <h3>More Microservices</h3>
  <p>
    The current Docker setup provide an stable infrastructure, allow me to add additional microservices on top with minimal of configurations. Such as a 24/7 Network-attached Storage (NAS) with Samba and an email delivery services to extend functionalities of my other microservices.
  </p>

  <h3>More Devices</h3>
  <p>
    The current architecture setup allows me to connect more commercial Zigbee devices such as <ES {...explains['SpritThermostat']}>Thermostat</ES> which provide temperature control for each individual rooms, saving energy and provide greater comfort. <br/>
    I can also make my own MQTT devices such as face recognition for better security, and E-ink display to display my todo list and major event in my calendar.
  </p>

  <h3>Better Security</h3>
  <p>
    As I add more devices and microservices, the current security boundary may not work as well. I may choice to move all smart devices to a new subnet and having another Raspberry Pi run as bastion host to filter and monitor at application level.
  </p>

  <h3>More Automations</h3>
  <p>
    With more devices in the network, I have more rooms to play with. I would be able to make more custom automation that will further improve my living standard. My ultimate goal is making the technology work for me while I don't feel their existence.
  </p>

</Typography>
)
export default data